// eslint-disable-next-line import/no-extraneous-dependencies
import { action, makeObservable, observable } from 'mobx';

class RoundTimeStore {
  time = null;

  constructor() {
    makeObservable(this, {
      time: observable,
      setTime: action.bound,
    });
  }

  setTime(time) {
    this.time = time;
  }
}

export const roundTimeStore = new RoundTimeStore();
